import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSelector() {
    const { t, i18n } = useTranslation();

    const changeLanguage = (event) => {
        i18n.changeLanguage(event.target.value);
    };

    return (
        <div className="language-selector">
            <span style={{ marginRight: '8px' }}>{t('languageLabel')}</span>
            <select
                value={i18n.language}
                onChange={changeLanguage}
                className="language-dropdown"
            >
                <option value="en">English</option>
                <option value="bg">Bulgarian</option>
                <option value="de">Deutsch</option>
                <option value="el">Ελληνικά</option>
                <option value="es">Español</option>
                <option value="fr">Français</option>
                <option value="it">Italiano</option>
                <option value="zh">简体中文</option>
                <option value="jp">日本語</option>
            </select>
        </div>
    );
}